import { render } from "./MonthlyReportList.vue?vue&type=template&id=4e2a5734&scoped=true&ts=true"
import script from "./MonthlyReportList.vue?vue&type=script&lang=ts"
export * from "./MonthlyReportList.vue?vue&type=script&lang=ts"

import "./MonthlyReportList.vue?vue&type=style&index=0&id=4e2a5734&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2602801780/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2a5734"]])

export default __exports__